import React, { useEffect, useRef } from 'react';
import * as BlazeSDK from '@wscsports/blaze-web-sdk';
import {
    configureBlazeTheme,
    getBlazeDataSource
} from './wsc-blaze-stories-utils';

const ROW_HEIGHT = '104px';

const WSCBlazeStoriesLayout = ({ options }) => {
    const {
        contentType, labels
    } = options;
    const displayTitle = options.displayTitle === true ||
                         (typeof options.displayTitle === 'string' && options.displayTitle.toLowerCase() === 'true');
    const wrapperRef = useRef(null);

    useEffect(() => {
        const apiKey = window.appState.wscBlazeConfig.environmentKey;
        if (!wrapperRef.current || !apiKey) {
            return;
        }

        const containerId = `wsc-container-${Math.random().toString(36).substr(2, 9)}`;
        const viewMethod = 'WidgetRowView';
        let playerContainer = null;
        let hasMountedWidget = false;

        const onConnect = () => {
            if (!BlazeSDK || hasMountedWidget) return;

            const dataSource = getBlazeDataSource(BlazeSDK, labels);
            const themeObject = configureBlazeTheme(BlazeSDK, contentType || 'story', displayTitle);

            if (typeof BlazeSDK[viewMethod] !== 'function') return;

            hasMountedWidget = true;

            BlazeSDK[viewMethod](containerId, {
                dataSource,
                theme: themeObject,
                contentType: contentType || 'story',
                delegates: {
                    [BlazeSDK.Delegations.onWidgetDataLoadCompleted]: (e) => {
                        if (playerContainer) {
                            playerContainer.style.display = e.detail.contentCount === 0 ? 'none' : '';
                        }
                    }
                }
            });
        };

        playerContainer = document.createElement('div');
        playerContainer.id = containerId;
        playerContainer.className = 'wsc-blaze-stories__mount';
        playerContainer.style.width = '100%';
        playerContainer.style.maxWidth = '100%';
        playerContainer.style.minWidth = '0';
        playerContainer.style.height = ROW_HEIGHT;
        playerContainer.style.minHeight = ROW_HEIGHT;
        wrapperRef.current.appendChild(playerContainer);

        document.addEventListener('onBlazeSDKConnect', onConnect);
        if (BlazeSDK.isInitialized && BlazeSDK.isInitialized()) {
            onConnect();
        } else {
            BlazeSDK.Initialize(apiKey, { runInShadowDom: false });
        }

        return () => {
            document.removeEventListener('onBlazeSDKConnect', onConnect);
            if (wrapperRef.current && playerContainer && playerContainer.parentNode) {
                wrapperRef.current.removeChild(playerContainer);
            }
        };
    }, [labels, contentType, displayTitle]);

    return (
        <div ref={wrapperRef} className="wsc-blaze-stories-wrapper"></div>
    );
};

export default WSCBlazeStoriesLayout;
